const isValidDate = (date: Date | null) => {
    if (!date || !(date instanceof Date)) {
        return false;
    }
    return !isNaN(date.getTime());
};

/**
 * True only for a real Date with a complete 4-digit year.
 * Intermediate keyboard years (1, 19, 199) are treated as incomplete.
 */
export const isFullDateFormat = (date: Date | null) => {
    if (!isValidDate(date) || !date) {
        return false;
    }
    const year = date.getFullYear();
    // Same intent as the old YYYY-MM-DD regex, but clearer for typed partial years
    return year >= 1000 && year <= 9999;
};

/** Format as YYYY-MM-DD with zero-padded year (needed for intermediate years while typing). */
export const formatDateToYMD = (date: Date): string => {
    const year = String(date.getFullYear()).padStart(4, '0');
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
};

/** Parse stored API string (YYYY-MM-DD) or Date for MUI DatePicker value/min/max. */
export const parseStoredDate = (raw: Date | string | null | undefined): Date | null => {
    if (raw == null || raw === '') {
        return null;
    }
    if (raw instanceof Date) {
        return isNaN(raw.getTime()) ? null : raw;
    }
    const s = String(raw);
    const d = new Date(s.includes('T') ? s : `${s}T00:00:00`);
    return isNaN(d.getTime()) ? null : d;
};
